export enum SelectionStage {
  ORIGIN = 'origin',
  RETURN = 'return',
}
